<template>
  <input
    type="text"
    @focus="resetSelectedProduct"
    class="form-control"
    readonly
    v-model="placeholder"
    id=""
    v-if="selectedProduct"
  />
  <!-- @keyup.enter.stop.native="addNewProduct" -->

  <!-- @keyup.enter.native="addNewProduct" -->
  <el-select
    v-else
    @change="productSelected"
    class="search productQuery darkBorder"
    @focus="options = []"
    v-model="value"
    :loading-text="loadingMsg"
    :no-data-text="noDataMsg"
    filterable
    remote
    :clearable="true"
    placeholder="بحث المنتجات بالاسم"
    :remote-method="remoteMethod"
    :loading="loading"
  >
    <!-- allow-create -->
    <div class="container-fluid">
      <div class="row headerSearch">
        <!-- <div class="col-md-3 p-0">
          <Span>السعر</Span>
        </div> -->

        <div class="col-md-7 p-0">
          <span style="float: right">اسم المنتج</span>
        </div>
        <!-- <div class="col-md-2 p-0">
          <span style="float: right"> المخزون</span>
        </div> -->
      </div>
    </div>
    <!-- <el-option slot="empty" value="">
    <span>sameh</span>
  </el-option> -->
    <el-option
      ref="productQuery"
      v-for="(item, index) in options"
      :key="index"
      :label="item.name"
      :value="item.id"
    >
      <div class="container-fluid" v-if="options.length > 0">
        <div class="row searchBody">
          <!-- <div class="col-md-3 p-0">
            <Span> {{ item.inventories[0].pivot.buy_cost }} </Span>
          </div> -->

          <div class="col-md-7 p-0">
            <span style="float: right"> {{ item.name }}</span>
          </div>
          <!-- <div class="col-md-2 p-0">
            <Span
              style="float: right"
              class=""
              :class="[
                (item.inventories[0].pivot.qty -
                  item.inventories[0].pivot.hold_qty) /
                  item.units_per_package <=
                0
                  ? 'red'
                  : 'number',
              ]"
              >{{
                numberToFixed(
                  (item.inventories[0].pivot.qty -
                    item.inventories[0].pivot.hold_qty) /
                    item.units_per_package
                )
              }}
            </Span>
          </div> -->
        </div>
      </div>
    </el-option>
    <el-option v-if="addNewProduct" value="0">إضافة منتج جديد</el-option>
  </el-select>
</template>

<script>
import axiosApi from "@/plugins/axios.js";

export default {
  props: ["supplier", "showStockZero", "activeSide", "allowCreateNewProduct"],

  data() {
    return {
      noDataMsg: "لا توجد بيانات متاحه",
      loadingMsg: " ... جاري تحميل البيانات",
      options: [],
      placeholder: "",
      searchValue: "",

      value: null,
      loading: false,
      selectedProduct: null,
    };
  },
  mounted() {},
  methods: {
    onInput(e) {
      console.log(e.target.value);
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    searchProductBarcode() {
      let barcode = document.querySelector(".productQuery input").value;
      if (this.supplier == null) {
        this.$message({
          type: "error",
          message: "عفوا حدد العميل اولا",
        });
      } else if (barcode.trim() == "") {
        // this.$message({
        //   type: "error",
        //   message: "عفوا حدد الباركود اولا",
        // });
      } else {
        const loading = this.$loading({
          lock: true,
          text: "جاري بحث المنتجات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        axiosApi
          .get(
            `products/barcode-search?barcode=${barcode.trim()}&customer=${
              this.supplier.id
            }`
          )
          .then((res) => {
            console.log("========= selected product ===========", res.data);
            this.options = [];
            this.$emit("selectedProductWithBarcode", {
              product: res.data[0],
              barcode: barcode.trim(),
            });
          })
          .catch(() => {
            this.$message({
              type: "error",
              message: "عفوا لا يوجد باركود للمنتج المتاح",
            });
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    addNewProduct() {
      // this.resetOptions();
      console.log(this.searchValue);
      this.$emit("addNewProduct", this.searchValue);
    },
    setValue(value) {
      this.value = value;
      this.selectedProduct = value;
      if (this.value != null) {
        this.placeholder = value.name;
      } else {
        this.placeholder = "";
      }
    },
    resetOptions() {
      document.querySelector(".productQuery input").blur();
      this.options = [];
    },
    resetSelectedProduct() {
      this.selectedProduct = null;
      this.placeholder = "";
      this.$emit("selectedProduct", {
        product: this.selectedProduct,
      });
      setTimeout(() => {
        document.querySelector(".productQuery input").focus();
      }, 100);
    },
    productSelected() {
      console.log(this.value);
      if (this.value > 0) {
        // console.log("productSelected", this.value);
        this.selectedProduct = this.options.filter((product) => {
          console.log("product", product);
          if (product.id == this.value) {
            return product;
          }
        })[0];

        this.$emit("selectedProduct", {
          product: this.selectedProduct,
        });
      } else {
        this.value = "";
        this.addNewProduct();
      }
    },
    remoteMethod(query) {
      this.searchValue = query;
      if (this.supplier != null) {
        if (query !== "") {
          this.selectedLabel = query;
          this.$emit("productQueryChange", {
            productQuery: this.selectedLabel,
          });
          this.loading = true;
          axiosApi
            .get(
              `products/search-purchases?name=${query}&supplier=${this.supplier.id}`
            )
            .then((res) => {
              this.loading = false;
              let hasStock = [];
              if (this.showStockZero) {
                hasStock = res.data;
              } else {
                hasStock = res.data.filter((product) => {
                  if (
                    product.inventories.length > 0 &&
                    product.inventories[0].pivot.qty -
                      product.inventories[0].pivot.hold_qty >
                      0
                  ) {
                    // console.log(product)
                    return product;
                  }
                });
              }

              this.options = hasStock;
            })
            .catch((e) => {
              this.loading = false;

              console.log(e);
            });
        } else {
          this.options = [];
        }
      } else {
        this.$message({
          // type: "warning",
          type: "error",
          message: "عفوا حدد المورد اولا",
        });

        document.querySelector(".productQuery input").value = "";

        document.querySelector(".supplierQuery input").focus();
      }
    },
  },
};
</script>
